<div class="d-flex">
  <div style="flex: 1">
    <input
      title="inputPassword"
      [type]="hidePassword ? 'password' : 'text'"
      class="input"
      [value]="value"
      (change)="onChange($event)"
      (keyup)="onChange($event)"
      (blur)="propagateTouched($event)"
    >
  </div>
  <div
    class="icon-container"
    (click)="togglePassword()"
  >
    <img
      *ngIf="hidePassword"
      src="assets/svg/ico_eye_hide.svg"
      alt="Password hidden"
      width="20"
    >
    <img
      *ngIf="!hidePassword"
      src="assets/svg/ico_eye.svg"
      alt="Password visible"
      width="20"
    >
  </div>
</div>